import { ChangeDetectionStrategy, Component } from '@angular/core';
import { KeycloakService } from '@macs-frontend/auth/services/keycloak.service';

@Component({
  selector: 'md-switch-account',
  templateUrl: 'switch-account.component.html',
  styleUrls: ['switch-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SwitchAccountComponent {
  constructor(private readonly keycloak: KeycloakService) {}

  get username(): string {
    return this.keycloak.username ?? '';
  }

  switchAccount(): void {
    // Keycloak holds one identity per browser session and refuses to
    // re-authenticate as a different user while a session exists, so
    // switching accounts requires ending the SSO session first. That is
    // why this is an explicit button and not automatic: simply landing on
    // a foreign tenant must not kill the user's session elsewhere.
    this.keycloak.logout(window.location.origin);
  }
}
